import { z } from "zod";
/**
 * Per-user UI preferences — sidebar favourites + collapsed sections.
 *
 * Response schema is LOOSE (plain string arrays) so a saved id that no
 * longer resolves to a nav-config item never breaks the GET — unknown ids
 * are filtered at render, not rejected here. Request schema is VALIDATED:
 * non-empty bounded strings, deduped, bounded array length, so a malformed
 * client payload is a typed 400 rather than unbounded JSONB growth.
 *
 * Stored values are nav-config `id`s (kebab-case), never hrefs.
 * Spec: docs/superpowers/specs/2026-06-07-sidebar-favourites-collapsible-design.md
 */
export const MAX_IDS = 50;
// Response: loose — never reject persisted data.
export const SidebarPreferencesSchema = z.object({
    favourites: z.array(z.string()),
    collapsedSections: z.array(z.string()),
});
// Request: validated + deduped.
const idArray = z
    .array(z.string().trim().min(1).max(64)) // nav-config ids are short kebab-case; 64 is a generous ceiling
    .max(MAX_IDS)
    .transform((arr) => [...new Set(arr)]);
export const SidebarPreferencesUpdateSchema = z.object({
    favourites: idArray,
    collapsedSections: idArray,
});
//# sourceMappingURL=ui-preferences.js.map